import {useCallback, useMemo} from 'react'
import {Box, Button} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../common/store'
import {addSprite3D, selectActiveScene} from '../../../common/components/store/scenesSlice'
import {useAppTokens} from '../../theme'
import type {ThemeTokens} from '../../theme'
import Sprite3DItem from './Sprite3DItem'

// ── Sprite3DPanel — add button + list of 3D sprite items ──────────

const Sprite3DPanel = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const tokens = useAppTokens()
  const sprites3d = useAppSelector((s) => selectActiveScene(s).sprites3d)
  const sx = useMemo(() => buildStyles(tokens), [tokens])

  const handleAdd = useCallback(() => {
    dispatch(addSprite3D())
  }, [dispatch])

  return (
    <Box>
      <Button variant="outlined" size="small" fullWidth startIcon={<AddIcon />} onClick={handleAdd} sx={sx.addButton}>
        {t('sprite3d.add')}
      </Button>
      <Box sx={sx.list}>
        {sprites3d.map((sprite) => (
          <Sprite3DItem key={sprite.id} sprite={sprite} />
        ))}
      </Box>
    </Box>
  )
}

const buildStyles = (tokens: ThemeTokens) => ({
  addButton: {
    fontSize: 12,
    textTransform: 'none' as const,
    color: tokens.text.primary,
    borderColor: tokens.accordion.border,
    marginBottom: '8px',
    '&:hover': {
      borderColor: tokens.text.secondary,
    },
  },
  list: {
    display: 'flex',
    flexDirection: 'column' as const,
  },
})

export default Sprite3DPanel
